<template>
  <div class="homework-list">
    <p class="title">班级信息</p>
    <ul class="classInfo">
      <li>
        <p class="f-left">班级名称：{{baseInfo.class_name}}</p>
        <p class="f-left">班级人数：{{baseInfo.student_number}}人</p>
      </li>
      <li>
        <div class="f-left">
          <p>所属课程：{{baseInfo.course_name}}</p>
          <p>创建时间：{{$pub.timestampToTime(baseInfo.created_at)}}</p>
        </div>
        <div class="f-left">
          <p>讲师名称：{{baseInfo.teacher_name}}</p>
          <p>助教名称：{{baseInfo.assistant_name}}</p>
        </div>
      </li>
      <li>
        <p>班级简介：{{baseInfo.description ? baseInfo.description : "无"}}</p>
      </li>
    </ul>
    <p class="title">作业信息</p>
    <Tabs v-model="homeworkShowType">
      <TabPane label="按作业展示" name="homework"></TabPane>
      <TabPane label="按学员展示" name="student"></TabPane>
    </Tabs>
    <div v-show="homeworkShowType == 'homework'">
      <Form :model="formHomework" inline :label-width="90">
        <FormItem label="作业名称">
          <Input v-model="formHomework.hw_name" placeholder="请输入作业名称关键字" style="width:200px;"></Input>
        </FormItem>
        <FormItem label="作业所属课时">
          <Select v-model="formHomework.course_periods_id" style="width:200px;">
            <Option
              v-for="(item, index) in periods"
              :value="item.periods_id"
              :key="index"
            >{{item.periods_name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="更新时间">
          <DatePicker
            ref="dateRangeHomework"
            type="datetimerange"
            placeholder="开始时间 - 结束时间"
            @on-change="onDateRangeHomework"
            style="width: 200px"
          ></DatePicker>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onSearchHomework">搜索</Button>
            <Button icon="md-undo" @click="onResetHomework">重置</Button>
          </div>
        </FormItem>
      </Form>
      <Grid
        ref="gridHomework"
        :columns="columnsHomework"
        :data-url="urlHomework"
        :search="formHomework"
        :rowsFormatter="onFormatterHomework"
        selectType
        keyField="order_id"
        method="get"
      >
        <template slot="action" slot-scope="{row}">
          <Button type="text" @click="onPreview(row)">预览</Button>
          <span>-</span>
          <Button type="text" @click="onStatis(row)">作业统计</Button>
        </template>
      </Grid>
    </div>
    <div v-show="homeworkShowType == 'student'">
      <Form :model="formStudent" inline :label-width="90">
        <FormItem label="学员名称">
          <Input v-model="formStudent.nickname" placeholder="请输入学员名称关键字" style="width:200px;"></Input>
        </FormItem>
        <FormItem label="手机号">
          <Input v-model="formStudent.mobile" placeholder="请输入手机号关键字" style="width:200px;"></Input>
        </FormItem>
        <FormItem label="最新提交时间">
          <DatePicker
            ref="dateRangeStudent"
            type="datetimerange"
            placeholder="开始时间 - 结束时间"
            @on-change="onDateRangeStudent"
            style="width: 200px"
          ></DatePicker>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onSearchStudent">搜索</Button>
            <Button icon="md-undo" @click="onResetStudent">重置</Button>
          </div>
        </FormItem>
      </Form>
      <Grid
        ref="gridStudent"
        :columns="columnsStudent"
        :data-url="urlStudent"
        :search="formStudent"
        :rowsFormatter="onFormatterStudent"
        selectType
        keyField="order_id"
        method="get"
      >
        <template slot="action" slot-scope="{row}">
          <Button
            type="text"
            :to="{name:'StudentHomeworkList', query:{ student_id:row.uid, class_grade_id:class_id}}"
          >学员作业列表</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>

<script>
export default {
  name: "homework-list",
  data() {
    return {
      class_id: this.$route.query.id,
      urlHomework: `/api/class/homework/list/${this.$route.query.id}`,
      urlStudent: `/api/class/students/homework/${this.$route.query.id}`,
      baseInfo: {},
      homeworkShowType: "homework",
      formHomework: {
        hw_name: "",
        course_periods_id: "",
        start_at: "",
        end_at: "",
        init() {
          this.hw_name = "";
          this.course_periods_id = "";
          this.start_at = "";
          this.end_at = "";
        }
      },
      formStudent: {
        nickname: "",
        mobile: "",
        start_at: "",
        end_at: "",
        init() {
          this.nickname = "";
          this.mobile = "";
          this.start_at = "";
          this.end_at = "";
        }
      },
      periods: [],
      columnsHomework: [
        {
          title: "作业名称",
          key: "homework_name",
          align: "center",
          minWidth: 150
        },
        {
          title: "作业所属课时",
          key: "course_period",
          align: "center",
          minWidth: 130
        },
        { title: "发布者", key: "publisher", align: "center", minWidth: 80 },
        {
          title: "客观题总题目数",
          key: "objective_amount",
          align: "center",
          minWidth: 80
        },
        {
          title: "主观题总题目数",
          key: "subjective_amount",
          align: "center",
          minWidth: 80
        },
        {
          title: "作业总份数",
          key: "student_number",
          align: "center",
          minWidth: 80
        },
        {
          title: "实交份数",
          key: "submit_amount",
          align: "center",
          minWidth: 80
        },
        {
          title: "待批阅",
          key: "approve_amount",
          align: "center",
          minWidth: 80
        },
        {
          title: "已批阅",
          key: "approved_amount",
          align: "center",
          minWidth: 80
        },
        { title: "完成度", key: "completeRate", align: "center", minWidth: 80 },
        {
          title: "更新时间",
          key: "updated_at",
          align: "center",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 130,
          fixed: "right"
        }
      ],
      columnsStudent: [
        { title: "学员名称", key: "nickname", align: "center", minWidth: 100 },
        { title: "手机号", key: "mobile", align: "center", minWidth: 100 },
        {
          title: "作业份数",
          key: "student_number",
          align: "center",
          minWidth: 80
        },
        {
          title: "实交份数",
          key: "submit_amount",
          align: "center",
          minWidth: 80
        },
        {
          title: "待批阅",
          key: "approve_amount",
          align: "center",
          minWidth: 80
        },
        {
          title: "已批阅",
          key: "approved_amount",
          align: "center",
          minWidth: 80
        },
        {
          title: "最新提交时间",
          key: "updated_at",
          align: "center",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 100,
          fixed: "right"
        }
      ]
    };
  },
  created() {
    this.requestClassBase();
    this.requestPeriod();
  },
  methods: {
    // on event
    onDateRangeHomework(range) {
      this.formHomework.start_at = range[0];
      this.formHomework.end_at = range[1];
    },
    onSearchHomework() {
      this.$refs.gridHomework.searchRefresh();
    },
    onResetHomework() {
      this.formHomework.init();
      this.$refs.dateRangeHomework.handleClear();
      this.onSearchHomework();
    },
    onFormatterHomework(rows) {
      rows.forEach(i => {
        i.student_number = i.student_number || 0;
        i.submit_amount = i.submit_amount || 0;
        i.approved_amount = i.approved_amount || 0;
        i.completeRate = i.submit_amount + "/" + i.student_number;
        if (i.updated_at > 0) {
          i.updated_at = this.$pub.timestampToTime(i.updated_at);
        } else {
          i.updated_at = "--";
        }
        let list = [];
        if (i.course) {
          list.push(i.course);
        }
        if (i.period) {
          list.push(i.period);
        }
        i.course_period = list.join("/");
        i.publisher = i.teacher_name || i.assistant_name;
      });
    },
    onDateRangeStudent(range) {
      this.formStudent.start_at = range[0];
      this.formStudent.end_at = range[1];
    },
    onSearchStudent() {
      this.$refs.gridStudent.searchRefresh();
    },
    onResetStudent() {
      this.formStudent.init();
      this.$refs.dateRangeStudent.handleClear();
      this.onSearchStudent();
    },
    onFormatterStudent(rows) {
      rows.forEach(i => {
        i.student_number = i.student_number || 0;
        i.submit_amount = i.submit_amount || 0;
        i.approved_amount = i.approved_amount || 0;
        if (i.updated_at > 0) {
          i.updated_at = this.$pub.timestampToTime(i.updated_at);
        } else {
          i.updated_at = "--";
        }
      });
    },
    onPreview(row) {
      this.$router.push({
        name: "StudentHomeworkPreview",
        query: {
          id: row.homework_id
        }
      });
    },
    onStatis(row) {
      this.$router.push({
        name: "HomeworkStatis",
        query: {
          hw_id: row.homework_id,
          class_id: this.class_id
        }
      });
    },
    // other
    // request
    requestClassBase() {
      this.$http
        .get(`/api/classGradeStudent/classBase/${this.class_id}`)
        .then(data => {
          this.baseInfo = data;
        });
    },
    requestPeriod() {
      this.$http
        .get(`/api/classHomework/student/periods/0/${this.class_id}`)
        .then(data => {
          this.periods = data;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.classInfo {
  padding: 0 30px 30px;
  li {
    line-height: 38px;
    font-size: 14px;
    overflow: hidden;
    p {
      padding-right: 80px;
    }
  }
}
</style>